import { render, staticRenderFns } from "./NeTreeForCreate.vue?vue&type=template&id=04890384&"
import script from "./NeTreeForCreate.vue?vue&type=script&lang=js&"
export * from "./NeTreeForCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports